function applyCpf(value = '') {
	let maskedValue = value.substr(0, 3)
	if (value.length > 3) maskedValue += '.' + value.substr(3, 3)
	if (value.length > 6) maskedValue += '.' + value.substr(6, 3)
	if (value.length > 9) maskedValue += '-' + value.substr(9, 2)
	return maskedValue
}

function onlyNumbers(value = '') {
	return value.replace(/[^0-9]/g, '')
}

function applyPhone(value = '') {
	const rawValue = onlyNumbers(value)
	let maskedValue = `(${rawValue.substr(0, 2)}) `
	if (rawValue.length == 11) {
		maskedValue += `${rawValue.substr(2, 5)} ${rawValue.substr(7, 4)}`
	} else {
		maskedValue += `${rawValue.substr(2, 4)} ${rawValue.substr(6, 4)}`
	}
	return maskedValue
}

function applyBrazilianCurrency(value = '') {
	return value
		.toFixed(2)
		.replace('.', ',')
		.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}

function normalize(text) {
	return text
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toUpperCase()
}

export const maskHelper = {
	applyCpf,
	applyPhone,
	onlyNumbers,
	applyBrazilianCurrency,
	normalize,
}
